import script from "./CreateVacancyTutorialOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateVacancyTutorialOverlay.vue?vue&type=script&setup=true&lang=js"

import "./CreateVacancyTutorialOverlay.vue?vue&type=style&index=0&id=98d5d9b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98d5d9b8"]])

export default __exports__